@if (showNotification) {
  <div class="sdps-grid-container" id="warning notification">
    <div class="col" style="padding-left: 0px; padding-right: 0px">
      <sdps-alert [type]="notificationType" style="margin-top: 0px; margin-bottom: 8px">
        <div class="sdps-messaging__text">
          @if (notificationBold) {
            <div>
              <b>{{ notificationBold }}</b>
            </div>
          }
          @if (notificationBold) {
            <br />
          }
          @if (notificationHeading) {
            <span [innerText]="notificationHeading"></span>
          }
          @if (notificationMessages.length === 1 && !notificationHeading) {
            <span [innerText]="notificationMessages[0]"></span>
          }
          @if (notificationMessages.length > 1 || notificationHeading) {
            @for (message of notificationMessages; track message) {
              <ol class="sdps-messaging--error__formList">
                <li [innerText]="message"></li>
              </ol>
            }
          }
        </div>
      </sdps-alert>
    </div>
  </div>
}
